<template>
  <v-dialog v-model="dialogVisible" max-width="520" persistent>
    <v-card class="editar-card">
      <div class="editar-header">
        <h3>Editar contato</h3>
        <v-btn icon small @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div class="fornecedor-box" v-if="props.fornecedor">
        <div class="fornecedor-grid">
          <div>
            <p class="meta-label">CNPJ</p>
            <p class="meta-value">{{ formatCNPJ(props.fornecedor.cnpj) }}</p>
          </div>
          <div>
            <p class="meta-label">Razão social | Nome fantasia</p>
            <p class="meta-value">
              {{ props.fornecedor.razao_social || '—' }} | {{ props.fornecedor.nome_fantasia || '—' }}
            </p>
          </div>
        </div>
      </div>

      <v-form ref="formRef" lazy-validation>
        <div class="editar-form">
          <v-text-field
              v-model="form.nome_representante"
              label="Nome *"
              outlined
              dense
              :rules="[requiredRule]"
          ></v-text-field>

          <v-text-field
              v-model="form.cargo_representante"
              label="Cargo *"
              outlined
              dense
              :rules="[requiredRule]"
          ></v-text-field>

          <v-text-field
              v-model="telefoneMasked"
              label="WhatsApp *"
              outlined
              dense
              :maxlength="15"
              :rules="[requiredRule, whatsappRule, telefoneDuplicadoRule]"
          ></v-text-field>

          <v-text-field
              v-model="form.email"
              label="E-mail *"
              outlined
              dense
              :rules="[requiredRule, emailRule, emailDuplicadoRule]"
              @input="form.email = ($event || '').toLowerCase()"
          ></v-text-field>
        </div>
      </v-form>

      <div v-if="duplicateInfo" class="duplicado-overlay">
        <div class="duplicado-box">
          <p class="duplicado-title">Contato duplicado</p>
          <p class="duplicado-desc">
            O contato ou e-mail informado já existe para o fornecedor <strong>{{ duplicateInfo.fornecedorNome || (props.fornecedor && props.fornecedor.razao_social) || '' }}</strong>
          </p>
          <div class="duplicado-actions">
            <v-btn text class="wc-btn-actions-light-light" @click="limparDuplicado">Voltar e corrigir</v-btn>
          </div>
        </div>
      </div>

      <div class="editar-footer">
        <v-btn text class="wc-btn-actions-light-light" @click="closeDialog">Cancelar</v-btn>
        <v-btn color="primary" class="wc-btn-actions-light-light" @click="handleSalvar">Salvar alterações</v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { defineProps, defineEmits } from "vue";
import useEditarContatoDialog from "@/components/webcotacao/composables/useEditarContatoDialog";

const props = defineProps({
  visible: { type: Boolean, default: false },
  fornecedor: { type: Object, default: () => ({}) },
  contato: { type: Object, default: () => ({}) },
  handleClose: { type: Function },
});

const emit = defineEmits(["salvar"]);

const {
  dialogVisible,
  formRef,
  duplicateInfo,
  form,
  telefoneMasked,
  closeDialog,
  handleSalvar,
  limparDuplicado,
  requiredRule,
  whatsappRule,
  emailRule,
  emailDuplicadoRule,
  telefoneDuplicadoRule,
  formatCNPJ,
} = useEditarContatoDialog(props, emit);
</script>

<style scoped>
.editar-card {
  padding: 24px;
  border-radius: 12px;
  min-width: 480px;
  position: relative;
  overflow: hidden;
}

.editar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.editar-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.fornecedor-box {
  background: #f8f9ff;
  border: 1px solid #e2e7f3;
  border-radius: 12px;
  padding: 12px 16px;
  margin-bottom: 16px;
}

.fornecedor-grid {
  display: grid;
  gap: 12px;
}

.meta-label {
  font-size: 11px;
  color: #8a94af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin: 0 0 2px;
}

.meta-value {
  margin: 0;
  color: #1b2745;
  font-weight: 500;
}

.editar-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.editar-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
}


.duplicado-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 10;
}

.duplicado-box {
  border: 1px solid #e2e7f3;
  border-radius: 12px;
  padding: 20px 16px;
  background: #fff;
  width: 100%;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 18px 40px -24px rgba(15, 29, 64, 0.65);
}

.duplicado-title {
  margin: 0;
  font-weight: 600;
  color: #0f1d40;
}

.duplicado-desc {
  margin: 6px 0 12px;
  color: #536182;
  font-size: 14px;
}

.duplicado-actions {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
